module.exports = __webpack_public_path__ + "static/media/2.296c1766.png";